import React from 'react';

interface ConfirmationModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  message: React.ReactNode;
  showOnlyOk?: boolean; // Optional flag to show only the OK button
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  onCancel,
  onConfirm,
  message,
  showOnlyOk = false, // Default to false
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 px-4">
      <div className="bg-white px-4 py-6 md:p-6 rounded-md shadow-lg max-w-sm w-full text-center">
        <p className="mb-4 text-gray-800">{message}</p>
        <div className="flex justify-center gap-4">
          {showOnlyOk ? (
            <button
              onClick={() => {
                onConfirm();
              }}
              className="px-4 py-2 bg-black text-white rounded hover:bg-gray-800"
            >
              OK
            </button>
          ) : (
            <>
              <button
                onClick={() => {
                  onConfirm();
                }}
                className="px-4 py-2 bg-black text-white rounded hover:bg-gray-800"
              >
                Yes
              </button>
              <button
                onClick={() => {
                  onCancel();
                }}
                className="px-4 py-2 bg-gray-300 text-gray-800 rounded hover:bg-gray-400"
              >
                No
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
